export default __webpack_public_path__ + "media/titles/title_2_locale_pt-c4ce6a2e.png";